import { matchesEngagementScope, type EngagementScope } from '../../../src/reports/shared/engagement-scope';
import type { AffiliateRollup, AlertRow } from '../types';
import { readHealthUrlState, writeHealthUrlState } from './engagement-health';

export function affiliateDrilldownUrl(name: string, scope: EngagementScope): string {
  const { filters } = readHealthUrlState(new URLSearchParams());
  return `/engagement-health?${writeHealthUrlState('alerts', { ...filters, ...scope, affiliate: [name] })}`;
}

export function rollupAffiliateAlerts(alerts: AlertRow[], scope: EngagementScope): AffiliateRollup[] {
  const byAffiliate = new Map<string, AffiliateRollup>();

  // Mirror the Engagement Health default view (showSnoozed = false): a coach
  // whose only alerts are currently snoozed shouldn't appear here, otherwise
  // the drilldown opens to an empty filtered list.
  const now = Date.now();
  const activeAlerts = alerts.filter(
    (a) => matchesEngagementScope(a, scope) && !(a.snooze && Date.parse(a.snooze.snoozedUntil) > now),
  );

  for (const a of activeAlerts) {
    for (const aff of a.deliveringAffiliates ?? []) {
      if (!aff.name) continue;
      const key = aff.name;
      const existing = byAffiliate.get(key);
      if (existing) {
        if (a.alertType === 'stalled_start') existing.stalledStart += 1;
        else if (a.alertType === 'near_completion') existing.nearCompletion += 1;
        else if (a.alertType === 'stale_activity_30d') existing.staleActivity30d += 1;
        else existing.staleActivity += 1;
        existing.total += 1;
      } else {
        byAffiliate.set(key, {
          name: key,
          email: aff.email,
          stalledStart: a.alertType === 'stalled_start' ? 1 : 0,
          nearCompletion: a.alertType === 'near_completion' ? 1 : 0,
          staleActivity: a.alertType === 'stale_activity' ? 1 : 0,
          staleActivity30d: a.alertType === 'stale_activity_30d' ? 1 : 0,
          total: 1,
          lastAlertAt: null,
        });
      }
    }
  }

  return Array.from(byAffiliate.values()).sort((a, b) => b.total - a.total);
}
